var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownExpanded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4543 14.4708C7.13003 14.1565 7.13236 13.6354 7.45944 13.324L12.0001 9L16.5405 13.324C16.8676 13.6354 16.8699 14.1565 16.5457 14.4708C16.2403 14.7669 15.7561 14.7703 15.4467 14.4786L12.0001 11.2303L8.5533 14.4786C8.24381 14.7703 7.75962 14.7669 7.4543 14.4708Z",
    fill: "#0063C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownExpanded);
export default __webpack_public_path__ + "static/media/dropdownExpanded.fec07af6ff30b2cb25fa9b2f93e1dea7.svg";
export { ForwardRef as ReactComponent };